import { render, staticRenderFns } from "./TeamTag.vue?vue&type=template&id=454d31d1&scoped=true&"
import script from "./TeamTag.vue?vue&type=script&lang=js&"
export * from "./TeamTag.vue?vue&type=script&lang=js&"
import style0 from "./TeamTag.vue?vue&type=style&index=0&id=454d31d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d31d1",
  null
  
)

export default component.exports